import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=5b5f8fab"
import script from "./AddSale.js?vue&type=script&lang=js&external"
export * from "./AddSale.js?vue&type=script&lang=js&external"
import style0 from "./AddSale.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports